<template>
  <!-- <div id="faq"> -->
  <div class="faq" id="faqs">
    <!-- <div class="vertical_lines">
				<div class="vl"></div>
				<div class="vl"></div>
				<div class="vl"></div>
				<div class="vl"></div>
			</div> -->
    <div class="faq_content container">
      <h1>FAQ</h1>
      <div class="accordion_wrapper">
        <div class="accordion">
          <div class="accordion" id="accordionFaq">
            <div
              class="accordion-item"
              v-for="item in accordionItems"
              :key="item.id"
            >
              <template v-if="item.header == 'Half-Season Plan FAQ’s'">
                <h3 class="sub_header">Half-Season Plan</h3>
              </template>
              <template v-else>
                <div>
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#${item.id}`"
                    >
                      <h3>
                        <!-- <span>{{ item.count }}</span> -->
                        {{ item.header }}
                      </h3>
                    </button>
                  </h2>

                  <div
                    :id="item.id"
                    class="accordion-collapse collapse"
                    :class="!item.collapse || 'show'"
                    data-bs-parent="#accordionFaq"
                  >
                    <div class="accordion-body">
                      <div
                        v-if="
                          item.header == 'How do I opt-out of my membership?'
                        "
                      >
                        <p>
                          <a
                            style="
                              color: #fff !important;
                              font-weight: bold;
                              font-family: 'Prompt';
                            "
                            :href="optOutLinkComputed"
                            target="_blank"
                            >CLICK HERE</a
                          >
                          to submit the Opt-Out Form. Your Member Services
                          Account Manager will be in touch to confirm your
                          decision.
                        </p>
                      </div>
                      <div
                        v-else-if="
                          item.header ==
                          'How can I learn more about club seating and suites at UBS Arena?'
                        "
                      >
                        <p>
                          <a
                            style="
                              color: #fff !important;
                              font-weight: bold;
                              font-family: 'Prompt';
                            "
                            @click="upgradeActive = true"
                            @click.prevent="(e) => $emit('upgradeShow', 'show')"
                            href="#"
                            >Click here</a
                          >
                          for information on upgrading your seats. You can also
                          speak to your Member Service Account Manager for more
                          information.
                        </p>
                      </div>
                      <div
                        v-else-if="
                          item.header ==
                          'Can I purchase Premium Memberships, Club Seating, or Suites?'
                        "
                      >
                        <p>
                          Yes, please
                          <a
                            style="
                              color: #fff !important;
                              font-weight: bold;
                              font-family: 'Prompt';
                            "
                            @click.prevent="(e) => $emit('modalShow', 'show')"
                            href="#"
                            >Click Here</a
                          >
                          or call 888-694-7537 to learn more about Club Seating
                          and Suites at UBS Arena.
                        </p>
                      </div>

                      <div
                        v-else
                        class="faq_text"
                        v-html="$sanitize(item.body)"
                      ></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "Faq",
  emit: ["optOutShow", "upgradeShow"],

  data() {
    return {
      benefitLink: "#benefits",
      pricingLink: "#account_summary",
      optOutLink: this.$store.getters["purl/getOptOutLink"],
      accordionItems: [
        {
          id: "one",
          count: "1",
          header: "Where is the Park?",
          body: `The Park is outside of UBS Arena across from the main entrance. <a href="https://www.theparkatubsarena.com/" target="_blank">Click Here</a> for more information.`,
        },
        {
          id: "two",
          count: "2",
          header: "Where is Belmont Park Village?",
          body: `Please <a href="https://www.belmontparkvillage.com/" target="_blank">Click Here</a> for more information.`,
          // body: "To learn more about the Pitchbook Suites, Spotlight Suites, Spotlight Club, UBS Club, Verizon Lounge, DIME Club, or the Hyundai Club at UBS Arena, please contact your Member Service Account Manager.",
        },
        {
          id: "three",
          count: "3",
          header: "What perks come with my membership?",
          body: `We’re excited to provide a variety of perks to Season Ticket Members. Scroll up to the 2025-26 Membership Perks section.`,
        },
        {
          id: "four",
          count: "4",
          header:
            "How do I gain access to the 2026 Olympic Kickoff event at UBS Arena?",
          body: `The only way to secure access to the Olympic Kickoff is through an Islanders Season Ticket Membership, and Members will have priority access to purchase Olympic Kickoff tickets. Availability will be limited.`,
        },
        {
          id: "five",
          count: "5",
          header: "What are my parking options?",
          body: `Season Ticket Members have discounted parking for the 2025-26 season, starting as low as $10 per game in the Emerald lot.`,
        },
        {
          id: "six",
          count: "6",
          header: "How do I purchase parking?",
          body: `Information on purchasing parking will come at a later date.`,
        },
        {
          id: "seven",
          count: "7",
          header: "What are my options for ADA parking accommodations?",
          body: `We have designated parking for guests with disabilities in all of our parking areas. Please note that all guests with disabilities who park in the accessible parking spots must have a valid disabled parking permit and/or plate on the vehicle. We encourage all guests to purchase parking in advance and arrive as early as possible. ADA shuttles will run on a regular schedule while parking areas are open. <br/><br/> If you need further clarification on ADA accessibility at UBS Arena, please contact your Member Services Account Manager or <a href="https://ubsarena.com/accessibility-guide/" target="_blank">CLICK HERE</a> for the UBS Arena Accessibility Guide.`,
        },
        {
          id: "sixteen",
          count: "8",
          header: "What is the Isles Rewards Program?",
          body: "New for the 2025-26 season, we have developed an online Rewards platform that will allow you to exchange Rewards Points for unique gifts and experiences. Stay tuned for more information on program details.",
        },
        // {
        // 	id: "eight",
        // 	count: "9",
        // 	header: "Can I add or drop seats?",
        // 	body: `Yes.  Connect with your Member Services Account Manager for more information.`,
        // },
        {
          id: "nine",
          count: "9",
          header: "When will I be able to access tickets to my account?",
          body: `UBS Arena is a mobile-only venue. You can access tickets through your <a href="https://am.ticketmaster.com/newyorkislanders/invoice?check_logged_in=1" target="_blank">Islanders Account Manager</a> or by logging into the UBS Arena app and selecting My Events. Tickets for the 2025-26 season will be available following the release of the 2025-26 season schedule.`,
        },
        {
          id: "ten",
          count: "10",
          header:
            "Can I purchase Premium Memberships, Club Seating, or Suites?",
          body: `Yes, please <span class="clickable">Click Here</span> or call 888-694-7537 to learn more about Club Seating and Suites at UBS Arena.`,
        },
        {
          id: "eleven",
          count: "11",
          header: "What forms of payment are accepted?",
          body: `We accept credit cards, wire transfers, and certified checks. Contact your account manager with questions. You can <a href="https://am.ticketmaster.com/newyorkislanders/invoice?check_logged_in=1" target="_blank">CLICK HERE</a> to update a credit card on your Islanders Account Manager.`,
        },
        // {
        // 	id: "twelve",
        // 	count: "13",
        // 	header: "How do I switch to a half season or quarter season plan?",
        // 	body: `Contact your Member Service Account Manager to learn about other plans and when they will be available.`,
        // },
        // {
        //   id: "thirteen",
        //   count: "12",
        //   header: "What are my parking options?",
        //   body: `Scroll up to the Seating & Pricing Section to view your Season Parking option.`,
        // },
        // {
        //   id: "fourteen",
        //   count: "13",
        //   header: "How do I purchase parking?",
        //   body: `Information on purchasing parking will come at a later date.`,
        // },
        // {
        //   id: "fifteen",
        //   count: "14",
        //   header: "What are my options for ADA parking accommodations?",
        //   body: `We have designated parking for guests with disabilities in all of our parking areas.  Please note that all guests with disabilities who park in the accessible parking spots must have a valid disabled parking permit and/or plate on the vehicle.  We encourage all guests to purchase parking in advance and arrive as early as possible.  ADA shuttles will run on a regular schedule while parking areas are open.<br/><br/>If you need further clarification on ADA accessibility at UBS Arena, please contact your Member Services Account Manager or <a href="https://ubsarena.com/accessibility-guide/" target="_blank">CLICK HERE</a> for the UBS Arena Accessibility Guide.`,
        // },
        // {
        //   id: "sixteen",
        //   count: "15",
        //   header: "What is the Isles Rewards Program?",
        //   body: "New for the 2025-26 season, we have developed an online Rewards platform that will allow you to exchange Rewards Points for unique gifts and experiences. Stay tuned for more information on program details.",
        // },
        // // {
        // //   id: "seventeen",
        // //   count: "16",
        // //   header: "What are Isles 365 Events?",
        // //   body: "New for the 2025-26 season, the team will host events at various locations throughout the calendar year, designed to give you a personalized Membership experience based on what matters most to you. Stay tuned for more information on event details and scheduling.",
        // // },
        // {
        //   id: "eighteen",
        //   count: "17",
        //   header:
        //     "I think my Tenure Level is wrong. How can I check into this?",
        //   body: "Our journey as an NHL franchise goes back to 1972, and we do our best to diligently track the tenure of our Members. If you have a question about the Tenure Level you see, please reach out to your Member Services Account Manager and we’ll work with you to ensure we have it correct. Tenure is defined as a continuous New York Islanders membership for a consecutive number of years.",
        // },
        // {
        //   id: "nineteen",
        //   count: "18",
        //   header: "How do I opt-out of my membership?",
        //   body: `<a href="${
        //     this.optOutLinkComputed || ""
        //   }" target="_blank">CLICK HERE</a> to submit the Opt-Out Form.  Your Member Services Account Manager will be in touch to confirm your decision.`,
        // },
      ],
    };
  },
  computed: {
    optOutLinkComputed() {
      return this.$store.getters["purl/getOptOutLink"]; // This keeps it reactive
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("click", this.handleClick);
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClick);
  },
  methods: {
    optOutHide() {
      this.OptoutActive = false;
    },
    handleClick(event) {
      if (event.target.classList.contains("clickable")) {
        this.$emit("modalShow", "show");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #ffffff !important;
}
body {
  counter-reset: section;
}

.faq {
  .vertical_lines {
    position: absolute;
    top: -50px;
    right: 200px;
    z-index: 10;
    display: flex;
    padding-left: 250px;
    @media only screen and (min-width: 578px) and (max-width: 900px) {
      right: 20px;
    }
    .vl {
      border-left: 40px solid theme-var($--ch-theme-secondary);
      height: 107px;
      padding: 14px;
      transform: skew(-20deg, 0deg);
      @include media-breakpoint-down(sm) {
        &:nth-last-child(-n + 2) {
          display: none;
        }
      }
    }
    @include media-breakpoint-down(sm) {
      position: absolute;
      right: 0px;
      padding-left: 0px;
    }
  }
  display: flex;
  position: relative;
  width: 100%;
  background: url("~images/faq/bg-faq.jpeg") no-repeat center;
  background-size: cover;
  @include media-breakpoint-down(sm) {
    overflow-x: clip;
  }
  &_content {
    padding: 100px 150px;
    @include media-breakpoint-down(sm) {
      padding: 50px 30px;
    }
    @media only screen and (min-width: 578px) and (max-width: 900px) {
      padding: 100px 30px;
    }
    z-index: 1;
    @include media-breakpoint-up(xl) {
    }
    h1 {
      color: #fff;
      text-align: center;
      font-family: Prompt;
      font-size: 96px;
      font-style: normal;
      font-weight: 900;
      line-height: 88px; /* 91.667% */
      letter-spacing: -0.305px;
      margin-bottom: 30px;

      @media screen and (max-width: 789px) {
        font-size: 48px;
        line-height: 48px;
      }
    }
    .sub_header {
      color: theme-var(--ch-theme-secondary);
      font-size: 30px;
      font-family: "Verlag Condensed Black";
      text-transform: uppercase;
      margin: 30px 0px;
    }
    .accordion {
      width: 100%;
      &_wrapper {
      }

      &-item {
        margin-bottom: 20px;
        border-radius: none;
        border: none;
        background-color: transparent;
        &:last-of-type {
          border-radius: 0 !important;
          .accordion-collapse {
            border-radius: 0 !important;
          }
        }
        &:first-of-type {
          border-radius: 0 !important;
          .accordion-collapse {
            border-radius: 0 !important;
          }
        }
        // &:before {
        //   counter-increment: section ;
        //   content: "faq " counter(section) ": ";
        // }
      }
      &-body {
        background-color: #212529;
        font-family: "Prompt";
        font-size: 16.5px;
        color: #ffffff;
        border: 2px solid #ffffff;
        border-top: none;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 145%;
        padding: 15px 15px 10px 30px;
        counter-reset: section;
        @include media-breakpoint-down(sm) {
          font-size: 12px;
        }
        .faq_text {
          a {
            font-size: 13px;
            color: #ffffff !important;
          }
        }
      }

      h2 {
        position: relative;
      }

      &-button {
        outline: none !important;
        background-color: #212529;
        border: 2px solid #ffffff;
        border-radius: none;
        padding: 15px 15px 10px 30px;
        &:focus {
          border-color: none;
          box-shadow: none;
        }

        &::after {
          position: absolute;
          right: 20px;
          top: 0%;
          flex-shrink: 0;
          width: 1.25rem;
          height: 1.25rem;
          content: url("~images/arrow.svg");
          background-image: revert;
          transform: translate(0px, 50%);
          @include media-breakpoint-down(sm) {
            padding: 0px 10px;
          }
        }

        &.collapsed {
          border: 2px solid #ffffff;

          &::after {
            transform: rotate(0deg);
            transition: transform 0.2s ease-in-out;
          }
        }
        &:not(collapsed) {
          border-bottom: none;
          h3 {
            color: white;
          }
          &::after {
            transform: rotate(-180deg);
            transition: transform 0.2s ease-in-out;
            position: absolute;
            top: 30%;
          }
        }

        h3 {
          color: theme-var($--ch-theme-on-primary);
          font-family: "Prompt";
          font-size: 15.5px;
          letter-spacing: 0;
          font-weight: 500;
          margin-right: 20px;
          text-transform: uppercase;
          display: flex;
          @include media-breakpoint-down(sm) {
            font-size: 12px;
            align-items: center;
          }

          span {
            font-family: "Prompt";
            font-size: 17px;
            color: #ffffff;
            letter-spacing: 2px;
            text-align: center;
            font-weight: 700;
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>
